var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 185 184.4",
    style: {
      enableBackground: "new 0 0 185 184.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EBFFE3;}\n\t.st1{fill:#BAFF9F;}\n\t.st2{fill:#52D670;}\n\t.st3{fill:#A4C2F7;}\n\t.st4{fill:#FFFFFF;}\n\t.st5{fill:#08CD34;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "strike",
    transform: "translate(0.088 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_049---Prize-Money",
    transform: "translate(-0.088 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(6.293 3.07)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-path",
    className: "st0",
    d: "M0.7,34.8h175c0.6,0,1,0.4,1,1v103c0,0.6-0.4,1-1,1H0.7c-0.6,0-1-0.4-1-1v-103 C-0.3,35.3,0.2,34.8,0.7,34.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "st1",
    d: "M172.5,33.8h-9.2c1.7,0,3.1,1.4,3.1,3.1v104.5c0,1.7-1.4,3.1-3.1,3.1c0,0,0,0,0,0h9.2 c1.7,0,3.1-1.4,3.1-3.1V36.9C175.6,35.2,174.2,33.8,172.5,33.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-path-2",
    className: "st1",
    d: "M14.7,46.8h40c1.1,0,2,0.9,2,2v3c0,1.1-0.9,2-2,2h-40c-1.1,0-2-0.9-2-2v-3 C12.7,47.7,13.6,46.8,14.7,46.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    className: "st2",
    d: "M52.7,46.1h-9.2c3.4,0,6.2,2.7,6.2,6.1c0,3.4-2.7,6.2-6.1,6.2c-0.1,0-0.1,0-0.2,0h9.2 c3.9,0,7-2.3,7-6.1s-3.1-7-7-7C52.7,45.3,52.7,45.3,52.7,46.1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_711",
    transform: "translate(93.258 144.448)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    className: "st1",
    d: "M51.6,14.2L49.4,0h-9.2l2,13.1L51.6,14.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-4",
    className: "st1",
    d: "M26,12.3l-3.8,11.5l8.1,3.3l4.6-13.8L26,12.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-5",
    className: "st1",
    d: "M5.9,20.9L0,29.2l5.9,4.6l7.1-10L5.9,20.9z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Shape-6",
    className: "st3",
    d: "M142.7,33.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-7",
    className: "st1",
    d: "M99.2,12.9l7.1-2.9L99.2,0l-5.9,4.6L99.2,12.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-8",
    className: "st1",
    d: "M119.2,21.5l8.9-1l-4.6-13.8l-8.1,3.3L119.2,21.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-9",
    className: "st1",
    d: "M135.5,20.7l-2,13.1h9.2l2.2-14.2L135.5,20.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icons_copy_2",
    transform: "translate(3.628 9.77)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape-10",
    className: "st4",
    d: "M40.2,14l-9.4-1.1l2.1,14.2h9.2L40.2,14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-11",
    className: "st4",
    d: "M42.1,137.7h-9.2l-2.1,14.2l9.4-1.1L42.1,137.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-12",
    className: "st4",
    d: "M60.2,161.5L56.4,150l-8.9,1l4.6,13.8L60.2,161.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-13",
    className: "st4",
    d: "M60.2,3.3L52.1,0l-4.6,13.8l8.9,1L60.2,3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-14",
    className: "st4",
    d: "M3.1,137.7h9.2c-1.7,0-3.1-1.4-3.1-3.1V30.2c0-1.7,1.4-3.1,3.1-3.1H3.1 c-1.7,0-3.1,1.4-3.1,3.1v104.5C0,136.4,1.4,137.7,3.1,137.7C3.1,137.7,3.1,137.7,3.1,137.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icons_copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-path-3",
    className: "st4",
    d: "M0.6,40h6.1v24.6H0.6V40z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_712"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    className: "st5",
    d: "M3,49.9c1.7,0,3,0,3,0S4.7,49.9,3,49.9s-3,0-3,0S1.3,49.9,3,49.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-15",
    className: "st5",
    d: "M178.8,33.8H6.7c-3.4,0-6.1,2.8-6.1,6.1c0,1.7,1.4,3.1,3.1,3.1s3.1-1.4,3.1-3.1h172.1v104.5 H6.7V64.5c0-1.7-1.4-3.1-3.1-3.1s-3.1,1.4-3.1,3.1v79.9c0,3.4,2.8,6.1,6.1,6.1c0,0,0,0,0,0h172.1c3.4,0,6.1-2.8,6.1-6.1l0,0V40 C185,36.6,182.2,33.8,178.8,33.8L178.8,33.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-16",
    className: "st5",
    d: "M15.9,116.8h153.7c1.7,0,3.1-1.4,3.1-3.1c0-1.7-1.4-3.1-3.1-3.1H15.9c-1.7,0-3.1,1.4-3.1,3.1 C12.8,115.4,14.2,116.8,15.9,116.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-17",
    className: "st5",
    d: "M28.2,104.5c1.7,0,3.1-1.4,3.1-3.1c0,0,0,0,0,0V86.1c0-1.7-1.4-3.1-3.1-3.1 c-0.8,0-1.6,0.3-2.2,0.9L23,87c-1.2,1.2-1.2,3.1,0,4.3c0.6,0.6,1.4,0.9,2.2,0.9v9.2C25.1,103.1,26.5,104.5,28.2,104.5 C28.2,104.5,28.2,104.5,28.2,104.5L28.2,104.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-18",
    className: "st5",
    d: "M37.4,92.2v3.1c0,5.1,4.1,9.2,9.2,9.2c5.1,0,9.2-4.1,9.2-9.2v-3.1c0-5.1-4.1-9.2-9.2-9.2 C41.6,83,37.4,87.1,37.4,92.2C37.4,92.2,37.4,92.2,37.4,92.2z M49.7,92.2v3.1c0,1.7-1.4,3.1-3.1,3.1c-1.7,0-3.1-1.4-3.1-3.1 v-3.1c0-1.7,1.4-3.1,3.1-3.1C48.4,89.1,49.7,90.5,49.7,92.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-19",
    className: "st5",
    d: "M89.7,95.3v-3.1c0-5.1-4.1-9.2-9.2-9.2c-5.1,0-9.2,4.1-9.2,9.2c0,0,0,0,0,0v3.1 c0,5.1,4.1,9.2,9.2,9.2C85.6,104.5,89.7,100.4,89.7,95.3z M77.4,95.3v-3.1c0-1.7,1.4-3.1,3.1-3.1c1.7,0,3.1,1.4,3.1,3.1v3.1 c0,1.7-1.4,3.1-3.1,3.1C78.8,98.3,77.4,97,77.4,95.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-20",
    className: "st5",
    d: "M114.3,95.3v-3.1c0-5.1-4.1-9.2-9.2-9.2c-5.1,0-9.2,4.1-9.2,9.2c0,0,0,0,0,0v3.1 c0,5.1,4.1,9.2,9.2,9.2C110.1,104.5,114.3,100.4,114.3,95.3z M102,95.3v-3.1c0-1.7,1.4-3.1,3.1-3.1s3.1,1.4,3.1,3.1v3.1 c0,1.7-1.4,3.1-3.1,3.1S102,97,102,95.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-21",
    className: "st5",
    d: "M120.4,95.3c0,5.1,4.1,9.2,9.2,9.2s9.2-4.1,9.2-9.2v-3.1c0-5.1-4.1-9.2-9.2-9.2 s-9.2,4.1-9.2,9.2V95.3z M126.6,92.2c0-1.7,1.4-3.1,3.1-3.1s3.1,1.4,3.1,3.1v3.1c0,1.7-1.4,3.1-3.1,3.1s-3.1-1.4-3.1-3.1V92.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-22",
    className: "st5",
    d: "M145,92.2v3.1c0,5.1,4.1,9.2,9.2,9.2c5.1,0,9.2-4.1,9.2-9.2v-3.1c0-5.1-4.1-9.2-9.2-9.2 C149.1,83,145,87.1,145,92.2z M157.3,92.2v3.1c0,1.7-1.4,3.1-3.1,3.1s-3.1-1.4-3.1-3.1v-3.1c0-1.7,1.4-3.1,3.1-3.1 S157.3,90.5,157.3,92.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-23",
    className: "st5",
    d: "M42.2,126.3c-1.4,0.7-2.6,1.4-3.8,2c-4.2,2.4-4.4,2.2-5,1.6c-0.7-0.8-1.3-1.7-1.7-2.7 c-0.8-1.6-1.9-3.9-4.5-3.9c-2.7,0-4.1,2.8-4.9,4.3c-1.8,3.7-3.4,4.4-3.7,4.5c-1.7,0.1-2.9,1.6-2.8,3.3c0.1,1.6,1.5,2.8,3.1,2.8 c0.8,0,4.6-0.3,8.2-6.5c0.5,0.9,1.2,1.8,1.9,2.6c4,4,8.3,1.7,12.3-0.6c1-0.6,2.2-1.2,3.5-1.9c4.1-2,8.7,2.5,8.7,2.5 c1.2,1.2,3.1,1.2,4.3,0c1.2-1.2,1.2-3.1,0-4.3l0,0C57.7,129.7,50.2,122.3,42.2,126.3L42.2,126.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-24",
    className: "st5",
    d: "M169.6,122.9h-12.3c-1.7,0-3.1,1.4-3.1,3.1s1.4,3.1,3.1,3.1h12.3c1.7,0,3.1-1.4,3.1-3.1 S171.3,122.9,169.6,122.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-25",
    className: "st5",
    d: "M68.2,55.3c0-5.1-4.1-9.2-9.2-9.2H22.1c-5.1,0-9.2,4.1-9.2,9.2s4.1,9.2,9.2,9.2h36.9 C64,64.5,68.2,60.4,68.2,55.3C68.2,55.3,68.2,55.3,68.2,55.3z M19,55.3c0-1.7,1.4-3.1,3.1-3.1h36.9c1.7,0,3.1,1.4,3.1,3.1 c0,1.7-1.4,3.1-3.1,3.1H22.1C20.4,58.4,19,57,19,55.3C19,55.3,19,55.3,19,55.3L19,55.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-26",
    className: "st5",
    d: "M163.4,55.3h6.1c1.7,0,3.1-1.4,3.1-3.1c0-1.7-1.4-3.1-3.1-3.1h-6.1c-1.7,0-3.1,1.4-3.1,3.1 C160.4,53.9,161.7,55.3,163.4,55.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-27",
    className: "st5",
    d: "M151.1,49.2h-27.7c-1.7,0-3.1,1.4-3.1,3.1c0,1.7,1.4,3.1,3.1,3.1h27.7c1.7,0,3.1-1.4,3.1-3.1 C154.2,50.5,152.8,49.2,151.1,49.2L151.1,49.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-28",
    className: "st5",
    d: "M34.8,164.8l13.9-1.6l4.1,12.4c0.3,0.8,0.9,1.5,1.6,1.8c0.8,0.4,1.7,0.4,2.5,0.1l12.9-5.3 l7.8,10.9c1,1.4,2.9,1.7,4.3,0.7c0,0,0.1-0.1,0.1-0.1l10.8-8.5l10.8,8.5c0.5,0.4,1.2,0.7,1.9,0.7c0.1,0,0.3,0,0.4,0 c0.8-0.1,1.6-0.6,2.1-1.3l7.8-10.9l12.9,5.3c1.6,0.6,3.4-0.1,4-1.7c0-0.1,0-0.1,0.1-0.2l4.1-12.4l13.9,1.6 c1.6,0.2,3.2-0.9,3.4-2.6c0,0,0-0.1,0-0.1c0.2-1.7-1-3.2-2.7-3.4c0,0,0,0,0,0l-16.4-1.9c-1.4-0.2-2.8,0.7-3.3,2.1l-3.9,11.7 l-12.1-4.9c-1.3-0.5-2.8-0.1-3.7,1.1l-7.3,10.3l-10.1-8c-1.1-0.9-2.7-0.9-3.8,0l-10.1,8l-7.4-10.2c-0.8-1.2-2.3-1.6-3.7-1.1 l-12.1,4.9l-3.9-11.7c-0.5-1.4-1.8-2.3-3.3-2.1l-16.4,1.9c-1.7,0.2-2.9,1.7-2.7,3.4c0,0,0,0,0,0C31.5,163.7,33,165,34.8,164.8 C34.7,164.8,34.7,164.8,34.8,164.8L34.8,164.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-29",
    className: "st5",
    d: "M50.4,27.6c1.4,0.2,2.8-0.7,3.3-2.1l3.9-11.7l12.1,4.9c1.3,0.5,2.8,0.1,3.7-1.1l7.3-10.3 l10.1,8c1.1,0.9,2.7,0.9,3.8,0l10.1-8l7.3,10.3c0.8,1.2,2.3,1.6,3.7,1.1l12.1-4.9l3.9,11.7c0.4,1.3,1.6,2.1,2.9,2.1 c0.1,0,0.2,0,0.4,0l16.4-1.9c1.7-0.2,2.9-1.7,2.7-3.4c0,0,0,0,0,0c-0.2-1.7-1.7-2.9-3.3-2.7c0,0-0.1,0-0.1,0l-13.9,1.6 l-4.1-12.4c-0.3-0.8-0.9-1.5-1.6-1.8c-0.8-0.4-1.7-0.4-2.5-0.1l-12.9,5.3l-7.8-10.9c-1-1.4-2.9-1.7-4.3-0.7c0,0-0.1,0.1-0.1,0.1 L92.8,9.1L82,0.7c-1.3-1-3.3-0.8-4.3,0.5c0,0-0.1,0.1-0.1,0.1l-7.8,10.9L56.9,6.9c-0.8-0.3-1.7-0.3-2.5,0.1 c-0.8,0.4-1.3,1-1.6,1.8l-4.1,12.4l-13.9-1.6c-1.7-0.2-3.2,1-3.4,2.6c0,0,0,0,0,0.1c-0.2,1.7,1,3.2,2.7,3.4c0,0,0,0,0,0 L50.4,27.6z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrike);
export default __webpack_public_path__ + "static/media/strike.4d43094c7b3c1d4b154f7f8d92d723fc.svg";
export { ForwardRef as ReactComponent };